<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 6.08867C16 4.38284 14.6172 3 12.9113 3H11.0887C9.38284 3 8 4.38284 8 6.08867V7.91133C8 9.61716 9.38284 11 11.0887 11H12.9113C14.6172 11 16 9.61716 16 7.91133V6.08867ZM11.0887 5H12.9113L13.03 5.00639C13.5754 5.06549 14 5.5275 14 6.08867V7.91133L13.9936 8.02995C13.9345 8.57541 13.4725 9 12.9113 9H11.0887L10.97 8.99361C10.4246 8.93451 10 8.4725 10 7.91133V6.08867L10.0064 5.97005C10.0655 5.42459 10.5275 5 11.0887 5Z"
      :fill="color"
    />
    <path
      d="M18 13C18 12.4477 17.5523 12 17 12H7L6.88338 12.0067C6.38604 12.0645 6 12.4872 6 13C6 13.5523 6.44772 14 7 14H17L17.1166 13.9933C17.614 13.9355 18 13.5128 18 13Z"
      :fill="color"
    />
    <path
      d="M13 15C13.5523 15 14 15.4477 14 16C14 16.5128 13.614 16.9355 13.1166 16.9933L13 17H7C6.44772 17 6 16.5523 6 16C6 15.4872 6.38604 15.0645 6.88338 15.0067L7 15H13Z"
      :fill="color"
    />
    <path
      d="M16 19C16 18.4477 15.5523 18 15 18H7L6.88338 18.0067C6.38604 18.0645 6 18.4872 6 19C6 19.5523 6.44772 20 7 20H15L15.1166 19.9933C15.614 19.9355 16 19.5128 16 19Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 1.33333C22 0.596954 21.403 0 20.6667 0H3.33333C2.59695 0 2 0.596954 2 1.33333V22.6667C2 23.403 2.59695 24 3.33333 24H20.6667C21.403 24 22 23.403 22 22.6667V1.33333ZM4 2H20V22H4V2Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ApplicationIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
